import { render, staticRenderFns } from "./drawing.vue?vue&type=template&id=33a6e651&scoped=true&"
import script from "./drawing.vue?vue&type=script&lang=js&"
export * from "./drawing.vue?vue&type=script&lang=js&"
import style0 from "./drawing.vue?vue&type=style&index=0&id=33a6e651&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a6e651",
  null
  
)

export default component.exports